
// TODO - Type 'any' needs to be fixed.
export const editDraftShiftDialogOpenReducer = (state:any, action:any) => {
    state.editDraftShiftDialog.isOpen = true;
    state.editDraftShiftDialog.shiftId = action.payload;
    state.editDraftShift.status = "idle";
    state.editDraftShift.errorMessage = "";
  }